import { render } from "./RouteSkeleton.vue?vue&type=template&id=5ef49a3b&scoped=true&lang=pug"
const script = {}

import "./RouteSkeleton.vue?vue&type=style&index=0&id=5ef49a3b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ef49a3b"

export default script